import './PieVisualization.scss';

export { schema, getSchema, uiSchema } from '../../schemas/PieVisualizationSchema';

export { default } from './PieVisualization';
